<script>
import EmployeeSales from '@/components/live/EmployeeSales'
import ItemTracking from '@/components/live/ItemTracking'
import { breadcrumbEventBus } from '@/main'
import LiveReportService from '@/services/ReportModules/LiveReportService'
import LocationTicketReport from '@/views/live/LocationTicketReport'

export default {
  created () {
    this.location_id = this.$route.params.location_id
  },
  data () {
    return {
      location: {},
      salesSummary: {},
      salesReportSetting: {
        columns: [
          {
            name: 'Shift',
            field: 'shift',
            textAlign: 'left'
          },
          {
            name: 'Guests',
            field: 'guests'
          },
          {
            name: 'Ticket',
            field: 'count'
          },
          {
            name: 'Sold',
            field: 'total',
            numberFormat: '$0,0.00',
            textAlign: 'right'
          }
        ],
        ordering: {
          column: 'total',
          reverse: true,
          limit: 3,
          showAll: false
        }
      },
      topEmployeesSetting: {
        columns: [
          {
            name: 'Employee',
            field: 'employee',
            textAlign: 'left'
          },
          {
            name: 'Tickets',
            field: 'count',
            sortable: true
          },
          {
            name: 'Sold',
            field: 'total',
            numberFormat: '$0,0.00',
            sortable: true,
            textAlign: 'right'
          }
        ],
        ordering: {
          column: 'total',
          reverse: true,
          limit: 3,
          showAll: false
        }
      },
      topItemsSetting: {
        columns: [
          {
            name: 'Item',
            field: 'item',
            textAlign: 'left'
          },
          {
            name: 'Quantity',
            field: 'quantity',
            sortable: true
          },
          {
            name: 'Sold',
            field: 'total',
            numberFormat: '$0,0.00',
            sortable: true,
            textAlign: 'right'
          }
        ],
        ordering: {
          column: 'total',
          reverse: true,
          limit: 3,
          showAll: false
        }
      }
    }
  },
  mounted () {
    this.$updateloading(2)
    LiveReportService.getLocationSales(this.location_id).then(data => {
      this.salesSummary = data
      this.$updateloading(-1)
    })
    LiveReportService.getLocation(this.location_id).then(data => {
      this.location = data
      this.setBreadcrumb()
      this.$updateloading(-1)
    })
  },
  methods: {
    setBreadcrumb: function () {
      const breadcrumb = []
      breadcrumb.push({ link: '/live/home', title: 'Home' })
      breadcrumb.push({
        link: '/live/location/' + this.location_id,
        title: this.location.name
      })
      breadcrumb.push({ link: null, title: 'Sales' })
      breadcrumbEventBus.$emit('breadcrumbChanged', breadcrumb)
    }
  },
  components: {
    EmployeeSales,
    ItemTracking,
    LocationTicketReport
  }
}
</script>

<template>
  <div>
    <div
      v-if="salesSummary.sales"
      class="row"
    >
      <div class="col-sm-12 col-lg-6 table-responsive">
        <EmployeeSales tableTitle="Employee Sales"></EmployeeSales>
      </div>
      <div class="col-sm-12 col-lg-6 table-responsive">
        <ItemTracking tableTitle="Tracked Items"></ItemTracking>
      </div>
    </div>
    <div
      v-if="salesSummary.sales"
      class="row"
    >
      <div class="col-sm-12 col-lg-6 table-responsive">
        <LocationTicketReport></LocationTicketReport>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
